import { CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { ListPropertyUser } from './PropertyUserApi'
import PaginationComponent from '../PaginationComponent/Pagination'
import EditNewPropertyUser from './EditPropertyUser/EditPropertyUser'
import AddUser from './AddUser'
import Swal from 'sweetalert2'
import SearchProperty from '../property/SearchProperty'

interface propertyUserListDataType {
  propertyUsers: {
    property_share: number
    rental_share: number
    account_uuid: string
    accouont_holder_name: string
    contact_number: string
    country_name: string
    email_id: string
    property_account_status: number
    property_account_type_name: string
    property_account_uuid: string
  }[],
  property_details: {
    property_id: number
    property_usage_type: number
    property_uuid: string
    propertytitle: string
    sub_unit_available: string
  },
  totalPropertyUsers: number
}
const PropertyUserHome = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean>(false)
  const [showAddUserModal, setShowAddUserModal] = useState<boolean>(false)
  const [showEditUserModal, setShowEditUserModal] = useState<string>()
  // const [apiDataPropertyUserList, setApiDataPropertyUserList] =
  //   useState<propertyUserListDataType[]>()
  const [searchInputValue, setsearchInputValue] = useState<string>('');
  const [propertyUserList, setPropertyUserList] = useState<propertyUserListDataType>()
  const [noDataFound, setNoDataFound] = useState<string | undefined>(undefined)
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const itemsPerPage = 10
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  // get property user list
  const getPropertyUserList = async () => {
    if (id) {
      setLoading(true)
      try {
        const { data: response } = await ListPropertyUser(id, itemOffset, itemsPerPage, searchInputValue)
        if (response.code === '200') {
          if (response?.data?.propertyUsers?.length > 0) {
            setPropertyUserList(response.data)
            // setApiDataPropertyUserList(response.data.propertyUsers)
            setDataLength(response.data.totalPropertyUsers)
            setNoDataFound(undefined)
          } else {
            setNoDataFound('No Data Found')
          }
        } else {
          setNoDataFound('No Data Found')
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
            text: response.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      } finally {
        setLoading(false)
      }
    }
  }

  // onload get property user list
  useEffect(() => {
    getPropertyUserList()
  }, [itemOffset, searchInputValue])

  // function to search user
  // const searchUser = (val: string) => {
  //   if (apiDataPropertyUserList && apiDataPropertyUserList?.length > 0) {
  //     let updatedUsers = apiDataPropertyUserList
  //     updatedUsers = apiDataPropertyUserList.filter((item: any) =>
  //       item.accouont_holder_name.toLowerCase().includes(val.toLowerCase())
  //     )
  //     setPropertyUserList(updatedUsers)
  //   } else {
  //     return
  //   }
  // }
  return (
    <>
      {/* // {* End: Loader *} */}
      <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
        <div className='d-flex flex-column flex-column-fluid'>
          <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 ps-2'>
            <div className='d-flex flex-column'>
              {/* Begin:: Heading */}
              <h1
                className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center mb-2'
              >
                Property Users
              </h1>
              {/* End:: Heading */}
              {/* Begin:: page Breadcrumb */}
              {/* <ol className='breadcrumb text-muted fs-6 fw-bold'>
                  <li className='breadcrumb-item pe-3'>
                    <a href='/property' className='pe-3'>
                      Property Users
                    </a>
                  </li>
                  <li className='breadcrumb-item pe-3'>{propertytitle}</li>
                </ol> */}
              <p className='breadcrumb text-muted fs-6 fw-bold'>Property: {propertyUserList?.property_details?.propertytitle}</p>
              {/* End:: page Breadcrumb */}
            </div>
            <div className='row g-2 justify-content-end'>
              {/* Begin: Search user field */}
              <div className='col-lg-6 col-12'>
                {/* <input
                    data-kt-user-table-filter='search'
                    placeholder='Search User'
                    className='form-control form-control-solid border-2 py-2 px-4 border-secondary'
                    // onChange={(e) => {
                    //   searchUser(e.target.value)
                    // }}
                  /> */}
                <SearchProperty
                  setCurrentPage={setCurrentPage}
                  setItemOffset={setItemOffset}
                  setsearchInputValue={setsearchInputValue}
                  placeholder="User"
                />
              </div>
              {/* End: Search user field */}
              {/* Begin: Add user button */}
              <div className='col-lg-4 col-12'>
                <button
                  className='btn btn-sm fw-bold btn-primary'
                  onClick={() => setShowAddUserModal(true)}
                >
                  Add User
                </button></div>
              {/* End: Add user button */}
              {/* Begin: Add user modal */}
              {showAddUserModal && propertyUserList && id && (
                <>
                  <AddUser
                    show={showAddUserModal}
                    handleClose={() => setShowAddUserModal(false)}
                    property_uuid={id}
                    property_title={propertyUserList?.property_details?.propertytitle}
                    getPropertyUserList={getPropertyUserList}
                    setCurrentPage={setCurrentPage}
                    setItemOffset={setItemOffset}
                  />
                </>
              )}
              {/* End: Add user modal */}
            </div>
          </div>
          {loading ? (
            // {* Begin: Loader *}
            <div
              className='d-flex justify-content-center align-items-center vh-70'
              style={{ height: '70vh' }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              <div id='table div'>
                <div className={`card mb-5 mb-xl-8`}>
                  {/* begin::Body */}
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        {!noDataFound && (
                          <thead>
                            <tr className='fw-bold text-muted'>
                              <th className='min-w-150px'>User</th>
                              <th className='min-w-150px'>Contact Details</th>
                              <th className='min-w-100px'>Role</th>
                              <th className='min-w-100px'>Property Share</th>
                              <th className='min-w-100px'>Rental Share</th>
                              <th className='min-w-100px'>Actions</th>
                            </tr>
                          </thead>
                        )}
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {noDataFound ? (
                            <tr>
                              <td colSpan={5}>
                                <span className='d-flex flex-column align-items-center flex-start p-10'>
                                  <img
                                    src='/media/svg/undraw/tenant.svg'
                                    alt='No document uploaded'
                                    className='h-200px w-200px'
                                  />
                                  <span className='fw-bold text-muted fs-1 text-center'>
                                    No users present
                                  </span>
                                </span>
                              </td>
                            </tr>
                          ) : (
                            propertyUserList && propertyUserList?.propertyUsers && propertyUserList?.propertyUsers?.length > 0 && propertyUserList?.propertyUsers?.map((user, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                      {user.accouont_holder_name}
                                    </span>
                                  </td>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                        {user.contact_number}
                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                          {user.email_id}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                      {user.property_account_type_name}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7 px-2'>
                                      {user.property_share ?? 0}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7 px-2'>
                                      {user.rental_share ?? 0}
                                    </span>
                                  </td>
                                  <td>
                                    <div className='d-flex flex-shrink-0'>
                                      <button
                                        type='button'
                                        className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        onClick={() => setShowEditUserModal(user.account_uuid)}
                                      >
                                        <i
                                          className='bi bi-pencil-square bi-4x fs-2'
                                          title='Edit User'
                                        ></i>
                                      </button>
                                      {showEditUserModal === user.account_uuid && (
                                        <EditNewPropertyUser
                                          property_account_uuid={user.property_account_uuid}
                                          setShowEditUserModal={setShowEditUserModal}
                                          showEditUserModal={showEditUserModal}
                                        />
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}
                  </div>
                  {/* begin::Body */}
                </div>
              </div>
              {/* Begin: Pagination */}
              {propertyUserList && propertyUserList?.propertyUsers?.length > 0 && pageCount > 1 && (
                <PaginationComponent
                  itemsPerPage={itemsPerPage}
                  dataLength={dataLength}
                  setItemOffset={setItemOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageCount={pageCount}
                />
              )}
              {/* End: Pagination */}</>
          )}
        </div>
      </div>
    </>
  )
}

export default PropertyUserHome
